import { render, staticRenderFns } from "./QualificationInstitution.vue?vue&type=template&id=5fd5ff02&"
import script from "./QualificationInstitution.vue?vue&type=script&lang=js&"
export * from "./QualificationInstitution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports